import { getApiUrl } from "core/utils/getApiUrl";

export function getImageSRC(blobName: string) {
  return getApiUrl(`/api/news-events/articles/download?fileId=${blobName}`);
}
